var _rect, _rect2, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EFF4F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D9F6E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1142_41301",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 28,
    height: 28
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9995,
    cy: 32,
    r: 13.9253,
    fill: "#6DC890"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1142_41301)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.9995,
    cy: 32,
    r: 13.9253,
    fill: "#51A5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5474 24.2595C23.001 23.7396 24.0698 18.5542 25.2975 16.0265C32.7505 13.08 43.5689 17.2542 48.0465 19.7097C47.3965 21.2263 44.6739 27.0168 40.9058 26.5152C35.7087 25.8234 40.7841 22.1534 35.4804 21.443C29.0345 20.5795 32.6639 24.6454 28.5474 24.2595Z",
    fill: "#0A5F59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3025 33.4983C42.2527 31.5529 43.4967 30.3259 47.3965 30.7591C47.6605 32.8693 48.1684 37.2194 48.0886 37.7381C48.0088 38.2569 45.5281 40.3152 44.2978 41.2796C43.5329 41.1632 41.7539 40.8107 40.7563 40.3319C39.5093 39.7333 39.7587 37.5885 41.1054 36.6906C42.4522 35.7928 42.3524 35.4436 42.3025 33.4983Z",
    fill: "#0A5F59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6069 26.8144C18.2103 25.6971 16.1985 25.9166 15.3672 26.166C16.8802 32.5672 20.2055 45.8885 21.4026 47.9635C22.899 50.5572 30.7301 48.562 32.027 47.1155C33.3239 45.669 31.3786 44.6714 29.8323 43.175C28.286 41.6786 32.426 40.0825 31.1292 37.3391C29.8323 34.5957 27.9369 36.94 26.1412 36.142C24.3455 35.3439 26.6899 33.1991 25.792 31.4034C24.8942 29.6077 23.2981 31.4533 21.9014 30.6053C20.5048 29.7574 21.3528 28.2111 19.6069 26.8144Z",
    fill: "#0A5F59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthericon);
export default __webpack_public_path__ + "static/media/Othericon.1dfcb973f446c7f3b243f2277b87ab0c.svg";
export { ForwardRef as ReactComponent };